import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import './Swiper.scss';
import React, { useEffect, useState } from 'react';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
SwiperCore.use([Autoplay, Pagination, Navigation])


class SwiperComponent extends React.Component {
    constructor(props) {
        super(props);
    }

	// 【非常重要】fixed: 多行swiper情况下，第一次进入页面时，某一行 出现 先快后慢、滑动一轮后才和其余几行达成一致 的步调
    componentDidMount() {
        this.carouselSwiper?.autoplay.stop(); // 关闭自动切换
        // 加个延时
        setTimeout(() => {
            this.carouselSwiper?.autoplay.start(); // 开启自动切换
        },500)
    }

    // TODO: 根据自己需求对下方两个数据进行调整（可以把autoplay关闭后慢慢调）
    firstContainerSlidesPerView = 1.25; // 第一个swiper-container的slidesPerView
    SecondSlidePaddingLeft = 0.8; // 第二个swiper-slide的paddingLeft值（第一个的值为0）

    render() {
        const {
            // 索引值
            index,
            // 当前轮播信息
            carouselInfo,
        } = this.props;

        return (
            <div className="barrageInner">
                {
                    carouselInfo?.length > 0 &&
                    <Swiper
                        className="barrage"
                        spaceBetween={80}
                        // 设置slider容器能够同时显示的slides数量(carousel模式)
                        slidesPerView={this.firstContainerSlidesPerView - index * 0.15}
                        //【关键👇🏻】匀速时间
                        speed={3000}
                        //【关键👇🏻】设置为true则变为free模式
                        freeMode={true}
                        // 设置为true 则开启loop(无限循环)模式
                        loop={true}
                        // 自动播放
                        autoplay={{
                            delay: 0, //【关键👇🏻】自动切换的时间间隔，单位ms
                        }}
                        onSwiper={swiper => { this.carouselSwiper = swiper; }}
                        style={{ paddingLeft: `${index * this.SecondSlidePaddingLeft}rem` }}
                    >
                        {
                            carouselInfo?.map((item, index) => {
                                return (
                                    <SwiperSlide className="barrageItem" key={index}>
                                        {/* slide背景图 */}
                                        {/* <div className="barrageItemBg"></div> */}
                                        {/* slide内容 */}
                                        <div className="barrageText text-hidden-ellipsis" dangerouslySetInnerHTML={{__html:item}}></div>
                                    </SwiperSlide>
                                )
                            })
                        }
                    </Swiper>
                }
            </div>);
    }
}
// export default () => {
//   return (
//     <Swiper
//       spaceBetween={10}
//       onSlideChange={() => console.log('slide change')}
//       onSwiper={(swiper) =>  console.log(swiper)  }
//       loop = { true }
//       observer = {true}
//       observeParents = {true}
//       observeSlideChildren = {true}
//       loopedSlides = {6}
//       slidesPerView = {"auto"}
//       updateOnWindowResize = {false}
//       freeMode = {true}
//       autoplay =  {{
//         delay : 0,
//         stopOnLastSlide :false,
//         // disableOnInteraction: false
//       }}
//       speed = { 5000 }
//     >
//       <SwiperSlide>Slide 1</SwiperSlide>
//       <SwiperSlide>Slide 2</SwiperSlide>
//       <SwiperSlide>Slide 3</SwiperSlide>
//     </Swiper>
//   );
// };

export default SwiperComponent;